import React, { Component } from "react";

import {
  CModal,
  CModalHeader,
  CModalTitle,
  CPopover,
  CButton
} from "@coreui/react";
import {
  AiOutlineInfoCircle,
  AiOutlineWarning,
  AiOutlineFullscreen,
  AiOutlineFullscreenExit
} from "react-icons/ai";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import NotesSidebar from "./NotesSidebar";
import { logout } from "../../actions/baseActions";
import {
  setShowInterfaceNotes,
  setInterfaceNotes,
  showHelpdesk,
  setShowNotes,
  setNotes,
  setObj
} from "../../actions/noteActions";
import URL from "../../config/api";
import axios from "../../config/axios";
import {
  AccessSessionTracker,
  hasGameficandusModule
} from "../../utils/accessSession";
import {
  conteudoDeJogoConcluido,
  origemConfiavel,
  resultadoDeJogo
} from "../../utils/jogos";
import { log } from "../../utils/log";
import ResumoPartida from "./ResumoPartida";
import "./styles.css";

/* `access_roles.id` do aluno — o mesmo número que a Sidebar e a página de
   atividade usam para decidir o que é tela de aluno. */
const ROLE_ALUNO = 7;

class Interface extends Component {
  static defaultProps = {
    modal: true
  };

  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      obj: null,
      type: null,
      url: "",
      Lo_info: null,
      children: null,
      resume: "",
      objective: "",
      converted: null,
      visible: false, // Estado para gerenciar a visibilidade da div suspensa
      showFullscreen: false,
      /* Resumo da ultima partida, exibido sobre o iframe. `null` = nada na tela.
         Guardado no estado (e nao derivado do POST) porque a tela nao depende do
         servidor: o aluno ve o desempenho mesmo se a chamada de XP falhar. */
      resumoPartida: null,
      interfaceValberto:
        "https://conteudos.educandus.com.br/aulasew/html5/interface/interface_em.html?arqXml=https://back.educandus.com.br/api/content/los/xml/"
    };

    this.accessSessionTracker = new AccessSessionTracker();

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleFullscreen = this.handleFullscreen.bind(this);
  }

  handleFullscreen() {
    if (
      !document.fullscreenElement && // Verifica se não está em tela cheia
      !document.mozFullScreenElement &&
      !document.webkitFullscreenElement &&
      !document.msFullscreenElement
    ) {
      const elem = document.documentElement; // ou use um ref para um elemento específico
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) {
        // Firefox
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) {
        // Chrome, Safari, Opera
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        // IE/Edge
        elem.msRequestFullscreen();
      }
    } else {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        // Firefox
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        // Chrome, Safari, Opera
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        // IE/Edge
        document.msExitFullscreen();
      }
    }
    this.setState(prevState => ({ showFullscreen: !prevState.showFullscreen }));
  }

  getUrl(loExecutionId) {
    let base = URL.interface;
    base += `?token=${this.props.user.token}`;
    base += `&id_aluno=${this.props.user.user.id}`;
    base += `&hybrid=${window.HYBRID}`;
    base += `&back=${URL.public}`;
    base += `&front=${window.location.origin}/`;

    if (this.props.aula !== undefined) {
      base += `&aula=${this.props.aula}`;
    }

    if (this.props.atividade !== undefined) {
      base += `&atividade=${this.props.atividade}`;
    }

    if (this.props.act_item_id !== undefined) {
      base += `&act_item_id=${this.props.act_item_id}`;
    }

    if (this.props.logo !== undefined) {
      base += `&logo=${this.props.logo}`;
    }

    if (this.props.botoes !== undefined) {
      base += `&botoes=${this.props.botoes}`;
    }

    if (this.props.act_type_id !== undefined) {
      base += `&act_type_id=${this.props.act_type_id}`;
    }

    if (this.props.sala !== undefined) {
      base += `&sala=${this.props.sala}`;
    }

    if (this.props.url) {
      base += `&url=${this.props.url}`;
    }

    if (this.props.pagina !== undefined) {
      base += `&pagina=${this.props.pagina}`;
    }

    if (this.props.act_execution_id !== undefined) {
      base += `&act_execution_id=${this.props.act_execution_id}`;
    }

    if (this.props.pages !== undefined) {
      let pages;
      if (typeof this.props.pages === "string") {
        pages = this.props.pages;
      } else {
        pages = this.props.pages.join(",");
      }
      base += `&pages=${pages}`;
    }

    if (loExecutionId !== undefined) {
      base += `&lms=${loExecutionId}`;
    }

    return base;
  }

  atualizarHelpdesk(page) {
    let id = this.state.Lo_info.children[page - 1].id;
  }

  componentDidMount() {
    window.addEventListener("message", this.receiveMessage, false);

    const startDate = new Date();

    const obj = {
      user_id: this.props.user.user.id,
      lo_id: this.props.aula,
      start: `${startDate.getFullYear()}-${
        startDate.getMonth() + 1
      }-${startDate.getDate()} ${startDate.getHours()}:${startDate.getMinutes()}:${startDate.getSeconds()}`,
      end: `${startDate.getFullYear()}-${
        startDate.getMonth() + 1
      }-${startDate.getDate()} ${startDate.getHours()}:${startDate.getMinutes()}:${startDate.getSeconds()}`,
      json: "{}",
      activity_id: this.props.atividade,
      lo_execution_id: null
    };

    if (this.props.aula) {
      axios
        .post(`${URL.api}content/los/execution/insert`, obj, {
          headers: { authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.setState({ url: this.getUrl(resp.data.data) });
        });
    } else {
      this.setState({ url: this.getUrl() });
    }

    if (this.props.fullscreen) {
      this.createLog();
      this.startAccessSessionTracking();
    }

    axios
      .get(`${URL.api}content/los/listLosLos/${obj.lo_id}`, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          Lo_info: resp.data.data,
          children: resp.data.data.children,
          resume: resp.data.data.resume,
          objective: resp.data.data.objective
        });
        if (resp.data.data?.converted) {
          this.setState({ converted: resp.data.data.converted });
        }
      });
  }

  /**
   * Registra a partida que o jogo acabou de reportar.
   *
   * Só para ALUNO, e o filtro é esse mesmo: o professor abre o conteúdo para
   * conferir e o jogo dispara o aviso igual, mas a partida dele não é registro
   * de ninguém. O servidor confere de novo (204 para quem não é aluno).
   *
   * NÃO exige o módulo Gameficandus, de propósito: registrar o desempenho é dado
   * pedagógico e vale para toda escola; o módulo decide só se a partida vira XP,
   * o que é decisão do servidor.
   *
   * O `lo_id` que a interface carimba é o da página aberta no instante em que a
   * partida acabou. O fallback daqui vale para o jogo que posta direto para o
   * topo, pulando a interface: `children[page - 1]` é a página atual, e a aula
   * inteira é o último recurso.
   */
  registrarJogoConcluido = event => {
    if (this.props.general.active_roles.role_id !== ROLE_ALUNO) {
      return;
    }

    const paginas = this.state.children;
    const paginaAtual = paginas?.[this.state.page - 1];

    const resultado = resultadoDeJogo(event.data, {
      loId: paginaAtual?.id || this.props.aula,
      activityId: this.props.atividade
    });

    if (!resultado) {
      return;
    }

    /* O resumo abre na hora, antes da resposta do servidor: o desempenho da
       partida veio na propria mensagem do jogo e nao depende de rede. Se o POST
       falhar, o aluno ainda ve acertos e erros — so nao ve XP. */
    /* Nome da pagina jogada: o mesmo `children[page - 1]` que alimenta o
       subtitulo do header ("1. IDENTIFICANDO QUANTIDADES"). NAO vem no
       postMessage — o jogo manda so o desempenho —, entao sai do React.
       So faz sentido quando a aula tem mais de uma pagina, igual ao header. */
    const paginaNome =
      paginas && paginas.length > 1 && paginaAtual && paginaAtual.name
        ? `${paginaAtual.order ? `${paginaAtual.order}. ` : ""}${
            paginaAtual.name
          }`
        : null;

    this.setState({
      resumoPartida: {
        titulo: this.props.title,
        pagina: paginaNome,
        /* Define a palavra da mensagem de XP ja creditado: "neste jogo" quando o
           conteudo se identificou como jogo, "nesta aula" caso contrario. */
        ehJogo: !!resultado.game_key,
        /* Guarda de INTERFACE, nao regra de negocio: quem decide XP e o servidor.
           Serve para nao dizer "voce ja ganhou XP hoje" a quem nunca ganharia por
           nao ter o modulo. Front e back comparam o mesmo id (62). */
        temGamificacao: hasGameficandusModule(this.props.user.user_modules),
        nivel: resultado.nivel,
        acertos: resultado.acertos,
        erros: resultado.erros,
        totalPerguntas: resultado.total_perguntas,
        xp: null
      }
    });

    axios
      .post(`${URL.api}gamification/games/complete`, resultado, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        /* O servidor devolve 204 sem corpo para quem nao e aluno, e o modulo de
           gamificacao inativo faz `xp_awarded` vir 0. Quem decide XP e ele, nao
           o front: aqui so exibimos o que foi creditado. */
        /* 204 sem corpo para quem nao e aluno. `xp_awarded` vem 0 quando o
           modulo esta inativo OU quando o aluno ja ganhou XP neste LO hoje — o
           modal distingue os dois casos com `temGamificacao`. */
        const dados = resp && resp.data && resp.data.data;

        if (!dados) {
          return;
        }

        /* Mescla so se o resumo ainda for o desta partida. Sem isso, uma resposta
           atrasada carimbaria XP no resumo da partida seguinte, ou reabriria um
           modal que o aluno acabou de fechar. */
        this.setState(estadoAtual =>
          estadoAtual.resumoPartida
            ? { resumoPartida: { ...estadoAtual.resumoPartida, xp: dados } }
            : null
        );
      })
      .catch(() => {
        // Sem alarde na tela: o aluno terminou o jogo, e uma falha ao creditar XP
        // não é problema dele. O erro fica no log do servidor, que é onde alguém
        // vai procurar.
      });
  };

  receiveMessage = event => {
    /* O aviso de fim de partida chega antes do switch porque vem em dois
       formatos — repassado pela interface (`message: "jogo_concluido"`) e direto
       do jogo (`type: "JOGO_CONCLUIDO"`), que não tem `message` nenhum. */
    if (origemConfiavel(event.origin) && conteudoDeJogoConcluido(event.data)) {
      this.registrarJogoConcluido(event);
      return;
    }

    const { message } = event.data;
    switch (message) {
      case "logout":
        this.props.logout();
        break;
      case "pagina":
        this.setState({ page: event.data.content });
        this.atualizarHelpdesk(event.data.content);
        break;
      case "objeto":
        this.setState(
          {
            obj: event.data.content.objeto,
            type: event.data.content.tipo
          },
          () => {
            if (this.props.fullscreen) {
              this.props.setObj(
                this.state.type,
                this.state.obj,
                this.props.currentRoute
              );
            }
          }
        );
        break;
    }
  };

  componentWillUnmount() {
    window.removeEventListener("message", this.receiveMessage, false);
    this.accessSessionTracker.stop();
  }

  createLog() {
    if (this.props.aula) {
      log(
        "access",
        this.props.currentRoute,
        `Acessou o conteúdo ${this.props.title}${
          this.props.atividade
            ? ` dentro da atividade com id ${this.props.atividade}`
            : ""
        }`,
        this.props.aula,
        this.props.user.token,
        this.props.atividade || null,
        this.props.general.active_roles.school_id || null
      );
    }
  }

  startAccessSessionTracking() {
    if (!this.props.aula) {
      return;
    }

    // Só aluno de rede com Gameficandus ganha XP e ofensiva por acesso. O backend
    // recusa os demais (204); aqui só se evita a chamada.
    if (
      this.props.general.active_roles.role_id !== ROLE_ALUNO ||
      !hasGameficandusModule(this.props.user.user_modules)
    ) {
      return;
    }

    this.accessSessionTracker.start(
      "los",
      this.props.aula,
      this.props.user.token
    );
  }

  handleMouseEnter() {
    this.setState({ visible: true });
  }

  handleMouseLeave() {
    this.setState({ visible: false });
  }

  handleClick() {
    // eslint-disable-next-line react/no-access-state-in-setstate
    this.setState({ visible: !this.state.visible });
  }

  /* Renderizado dentro do wrapper de cada iframe (que precisa ser
     `position: relative`), para o veu cobrir a area do conteudo e nao a
     viewport inteira. Ha tres pontos de iframe no render abaixo. */
  renderResumoPartida() {
    if (!this.state.resumoPartida) {
      return null;
    }

    return (
      <ResumoPartida
        {...this.state.resumoPartida}
        onFechar={() => this.setState({ resumoPartida: null })}
      />
    );
  }

  render() {
    if (this.state.converted) {
      // Implementação especial para tratar as aulas que são especificamente do VALBERTO.
      // Essas aulas devem abrir no caminho especial da interface dele:

      if (this.state.converted === "VALBERTO") {
        window.open(
          `${this.state.interfaceValberto}${this.props.aula}`,
          "_self"
        );
        return;
      }

      if (this.props.fullscreen) {
        return (
          <>
            {/* START: HEADER */}
            {!this.state.showFullscreen && (
              <div
                className="w-100 p-2 d-flex justify-content-between align-items-center"
                style={{ borderBottom: "1px solid #d8dbe0" }}
              >
                <div className="container-header">
                  <div className="d-flex flex-column">
                    <div className="d-flex" id="trigger-text">
                      <div className="d-flex align-self-start">
                        <AiOutlineInfoCircle
                          id="icon-title-header"
                          onMouseEnter={this.handleMouseEnter}
                          onMouseLeave={this.handleMouseLeave}
                          onClick={this.handleClick}
                        />
                      </div>
                      <div className="d-flex flex-column">
                        <span
                          id="title-header"
                          style={{
                            margin: "0px 0px 0px 3px",
                            lineHeight: "1.25rem",
                            cursor: "pointer"
                          }}
                          onMouseEnter={this.handleMouseEnter}
                          onMouseLeave={this.handleMouseLeave}
                          onClick={this.handleClick}
                        >
                          {this.state.Lo_info.name}
                        </span>

                        {this.state.children.length > 1 && (
                          <span id="subtitle-header">
                            {`${
                              this.state.children[this.state.page - 1]?.order
                                ? `${
                                    this.state.children[this.state.page - 1]
                                      ?.order
                                  }. `
                                : ""
                            } ${
                              this.state.children[this.state.page - 1]?.name
                            }`}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  {/* START: POPOVER */}
                  {this.state.visible && (
                    <div id="hover-div">
                      <div
                        className="d-flex flex-column gap-3 w-30"
                        style={{ overflow: "auto" }}
                      >
                        <div>
                          <h6 style={{ fontWeight: "800" }}>Objetivo</h6>
                          <p>{this.state.objective}</p>
                        </div>
                        <div>
                          <h6 style={{ fontWeight: "800" }}>Resumo</h6>
                          <p>{this.state.resume}</p>
                        </div>
                        <div>
                          <h6 style={{ fontWeight: "800" }}>
                            Total de Páginas:
                          </h6>
                          <p>{this.state.children.length}</p>
                        </div>
                      </div>
                    </div>
                  )}
                  {/* END: POPOVER */}
                </div>

                <div className="w-30 hide-on-mobile-576">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "end",
                      alignItems: "center"
                    }}
                  >
                    <CButton
                      id="button-helpdesk-header"
                      color="info"
                      onClick={() =>
                        this.props.showHelpdesk(
                          this.state.type,
                          this.state.obj,
                          this.state.type === 1 ? this.state.page : null
                        )
                      }
                    >
                      Abrir Chamado
                    </CButton>
                  </div>
                </div>
              </div>
            )}
            {/* END: HEADER */}

            <div id="screen" className="position-relative">
              <iframe
                className="border-0 w-100 flex-1"
                src={this.state.url}
              ></iframe>
              {this.renderResumoPartida()}
            </div>
            {/* START: TRIGGER MENU MOBILE */}
            <div className="trigger-mobile">
              <div
                id="trigger-fullscreen"
                onClick={() => this.handleFullscreen()}
              >
                {this.state.showFullscreen ? (
                  <AiOutlineFullscreenExit />
                ) : (
                  <AiOutlineFullscreen />
                )}
              </div>
            </div>
            {/* END: TRIGGER MENU MOBILE */}
          </>
        );
      }

      return (
        <>
          {this.props.modal ? (
            <CModal
              show={this.props.show}
              onOpened={() => {
                this.createLog();
                this.startAccessSessionTracking();
              }}
              onClose={this.props.onClose}
              size="lg w-100 h-100 m-0 p-2 mw-100"
              style={{ width: "100%", height: "100%" }}
              closeOnBackdrop={false}
              /* Gancho de estilo, sem estilo nenhum por si: é o que permite a um
                 tema pintar ESTE modal — o que abre conteúdo — sem alcançar os
                 outros modais da mesma tela. A trilha lúdica usa (ver
                 `TrilhaLudica/ava/modalDoItem.css`); qualquer outro tema pode
                 usar. Nenhuma regra do AVA depende dela hoje. */
              className="modal-conteudo"
            >
              <CModalHeader closeButton>
                <CModalTitle className="flex-1">{this.props.title}</CModalTitle>
                <div className="align-self-center">
                  <i
                    className="fa fa-warning mr-4"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.props.showHelpdesk(
                        this.state.type,
                        this.state.obj,
                        this.state.type === 1 ? this.state.page : null
                      )
                    }
                  ></i>
                  <i
                    className="fa fa-sticky-note-o mr-4"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      this.props.setShowInterfaceNotes(true);
                      this.props.setInterfaceNotes(
                        this.state.type,
                        this.state.obj
                      );
                    }}
                  ></i>
                </div>
              </CModalHeader>
              <div
                className="w-100 h-100 position-relative"
                style={{ overflow: "hidden" }}
              >
                <NotesSidebar objId={this.state.obj} typeId={this.state.type} />
                {this.props.show && (
                  <iframe
                    className="border-0 w-100 h-100"
                    src={this.state.url}
                  ></iframe>
                )}
                {this.renderResumoPartida()}
              </div>
            </CModal>
          ) : (
            <div className="w-100 h-100 position-relative">
              <iframe
                className="border-0 w-100 h-100"
                src={this.state.url}
              ></iframe>
              {this.renderResumoPartida()}
            </div>
          )}
        </>
      );
    }
    return null;
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setShowInterfaceNotes,
      showHelpdesk,
      setInterfaceNotes,
      setShowNotes,
      setNotes,
      setObj
    },
    dispatch
  );
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

export default connect(mapStateToProps, mapDispatchToProps)(Interface);
